import { toast } from "react-toastify";
import { BaseUrl } from "../BaseUrl/BaseUrl";
import CustomToast from "../Components/CustomToast/CustomToast";

export const POST_LOGIN = "POST_LOGIN";
export const UPDATE_LOGIN_DATA = "UPDATE_LOGIN_DATA";
export const UPDATE_LOGIN_DATA_TOKEN = "UPDATE_LOGIN_DATA_TOKEN";
export const LOADER = "LOADER";
export const CLIENTSDATA = "CLIENTSDATA";
export const SINGLECLIENT = "SINGLECLIENT";
export const SINGLEADMIN = "SINGLEADMIN";
export const SUBLOADER = "SUBLOADER";
export const LOGOUTLOADER = "LOGOUTLOADER";
export const EMPLOYEESDATA = "EMPLOYEESDATA";
export const SINGLEEMPLOYEE = "SINGLEEMPLOYEE";
export const ADDASSET = "ADDASSET";
export const ROLEDROPDOWN = "ROLEDROPDOWN";
export const ROLESDATA = "ROLESDATA";
export const ROLEIDDATA = "ROLEIDDATA";
export const LEADDATA = "LEADDATA";
export const LEADIDDATA = "LEADIDDATA";
export const SUPPORTDATA = "SUPPORTDATA";
export const SUPPORTIDDATA = "SUPPORTIDDATA";
export const TASKSDATA = "TASKSDATA";
export const TASKSDATAEMP = "TASKSDATAEMP";
export const ASSETEMP = "ASSETEMP";
export const LEADEMP = "LEADEMP";
export const TRAVELEMP = "TRAVELEMP";
export const ACTIVETAB = "ACTIVETAB";
export const INVOICE = "INVOICE";
export const STATS = "STATS";
export const EMPSTATS = "EMPSTATS";
export const PIPELINEOVERVIEW = "PIPELINEOVERVIEW";
export const TOPSALE = "TOPSALE";
export const ASSETSSTATS = "ASSETSSTATS";
export const EMPTY = "EMPTY";
export const SALE = "SALE";
export const BILL = "BILL";
export const GET_TRANSACTION_BY_CLIENT_ID = "GET_TRANSACTION_BY_CLIENT_ID";
export const SINGLEASSET = "SINGLEASSET";
export const SINGLEASSETS = "SINGLEASSETS";
export const REVENUE = "REVENUE";
export const SALEGROWTH = "SALEGROWTH";
export const ASSETSSTATSMANGEMENT = "ASSETSSTATSMANGEMENT";
export const NOTIFICATIONCOUNT = "NOTIFICATIONCOUNT";
export const NOTIFICATION = "NOTIFICATION";
export const POPUP = "POPUP";
export const QUATERLYSALES = "QUATERLYSALES";
export const TOPCLIENT = "TOPCLIENT";
export const ACTIVITYBYID = "ACTIVITYBYID";
export const RECENTACTIVITY = "RECENTACTIVITY";

export const refreshToken = () => {
  return async (dispatch) => {
    const token = localStorage.getItem("refreshToken");
    const raw = JSON.stringify({
      token: token,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(`${BaseUrl}/api/auth/refresh-token`, requestOptions);
      const result = await response.json();
      console.log(result, "refresh tpoken result");
      if (result.success === true) {
        localStorage.setItem("accessToken", result?.data?.accessToken);
        localStorage.setItem("refreshToken", result.data.refreshToken);

        dispatch({
          type: UPDATE_LOGIN_DATA_TOKEN,
          payload: result.data,
        });
        // toast.success(<CustomToast type={'Success'} message={result?.message} />, {
        //   position: "top-right",
        //   autoClose: 3000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   pauseOnHover: false,
        //   draggable: false,
        //   progress: undefined,
        //   icon: false,
        //   closeButton: false
        // })
      } else {
        // toast.success(<CustomToast type={'Error'} message={result?.message} />, {
        //   position: "top-right",
        //   autoClose: 3000,
        //   hideProgressBar: true,
        //   closeOnClick: true,
        //   pauseOnHover: false,
        //   draggable: false,
        //   progress: undefined,
        //   icon: false,
        //   closeButton: false
        // })
        dispatch({
          type: EMPTY,
        });

        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/";
      }
    } catch (error) {
      console.error(error);
      dispatch({
        type: EMPTY,
      });

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.href = "/";

      // dispatch(Logout(token, () => { }));
    }
  };
};

export const postLogin = (email, password, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Access-Control-Allow-Origin", "*");

      const raw = JSON.stringify({
        email: email,
        password: password,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/auth/login`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result, "result");
          console.log(result.success, "2result");
          if (result.success == true) {
            console.log(result, "result");
            if (result?.data?.loginFor == "Employee" && result?.data?.roleName == "Sales Executive") {
              dispatch({ type: LOADER, payload: false });
              toast.success(
                <CustomToast type={"Success"} message={"Sales Executives are advised to login on Mobile App"} />,
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  icon: false,
                  closeButton: false,
                }
              );
            } else {
              dispatch({
                type: POST_LOGIN,
                payload: result.data,
                role: result.data.loginFor,
                Privilages: result.data.loginFor == "Employee" ? result?.data?.Privilages : [],
              });
              func(result.data);
              dispatch({ type: LOADER, payload: false });
              localStorage.setItem("accessToken", result.data.accessToken);
              localStorage.setItem("refreshToken", result.data.refreshToken);
            }
          } else {
            dispatch({ type: LOADER, payload: false });

            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const addClient = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client`, requestOptions)
        .then(async (response) => {
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const sendRemider = (id, token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/${id}/send-payment-reminder`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const updateClient = (clientId, data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/${clientId}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client response: ", result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateSelfEmployee = (id, data, token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/employees/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          dispatch({ type: UPDATE_LOGIN_DATA, payload: result?.employee });
          console.log("update employee response: ", result);

          if (result.success == true) {
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateTaskReminder = (taskId, data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/tasks/${taskId}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update task response: ", result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const toggleClientActivation = (clientId, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/${clientId}/toggle-status`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client activaton response: ", result);

          if (result.success == true) {
            func(result);
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const toggleEmployeeActivation = (employeeId, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/employees/${employeeId}/toggle-status`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update employee activaton response: ", result);

          if (result.success == true) {
            func(result);
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getClient = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "get client");
            dispatch({
              type: CLIENTSDATA,
              payload: [...result?.clients],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getClientbyid = (token, id, func, func2) => {
  try {
    return async (dispatch) => {
      // dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func(result);
            func2();
            dispatch({
              type: SINGLECLIENT,
              payload: { ...result?.client },
            });
          } else {
            func2();
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAdminbyid = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/users/userId/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "adminbyidget");
            // return
            func(result);
            dispatch({
              type: SINGLEADMIN,
              payload: { ...result?.data },
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const deleteClient = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/client/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          console.log(result);
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const postForgetPass = (email, func) => {
  console.log("forgot==>", email);

  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        email: email,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/auth/forgot-password`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          dispatch({ type: LOADER, payload: false });
          if (result.success == true) {
            func();
          }
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};
export const postResetPass = (password, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        token: token,
        newPassword: password,
        confirmPassword: password,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/auth/reset-password`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          dispatch({ type: LOADER, payload: false });
          if (result.success == true) {
            func();
          }
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};
export const Logout = (token, func) => {
  try {
    return async (dispatch) => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify({
        token: token,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/auth/logout`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          const result = await response.json();
          return result;
        })
        .then((result) => {
          dispatch({ type: LOGOUTLOADER, payload: true });
          console.log(result);
          if (result.success == true) {
            console.log(result);
            dispatch({
              type: EMPTY,
            });
          }
          func();
          dispatch({ type: LOGOUTLOADER, payload: false });
        })
        .catch((error) => {
          func();
          dispatch({ type: LOGOUTLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};

export const addEmpolyee = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/employees`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const getEmployees = (token, call) => {
  try {
    return async (dispatch) => {
      call ? dispatch({ type: LOADER, payload: false }) : dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/employees/client`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "get client");
            dispatch({
              type: EMPLOYEESDATA,
              payload: [...result?.employees],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const deleteEmployee = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/employees/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          func();
          console.log(result);
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const deleteTaskReminder = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/tasks/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          func();
          console.log(result);
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const getEmployeebyid = (token, id) => {
  try {
    return async (dispatch) => {
      // dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/employees/By?id=${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log("getEmployeebyid", result);
            dispatch({
              type: SINGLEEMPLOYEE,
              payload: { ...result?.employee },
            });
          }
          // dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          // dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateEmployee = (empId, data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/employees/${empId}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client response: ", result);

          if (result.success == true) {
            func();
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
//RoleManagement
export const addRoles = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token, "ppp");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/roles`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);
          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.error(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getRoles = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/roles`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "getroles");
            dispatch({
              type: ROLESDATA,
              payload: result?.roles?.length > 0 ? [...result?.roles] : [],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const deleteRole = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/roles/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          func();
          toast.success(<CustomToast type={"Success"} message={result?.message} />, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            icon: false,
            closeButton: false,
          });
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getRolebyid = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/roles/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "data");
            dispatch({
              type: ROLEIDDATA,
              payload: { ...result?.role },
            });
          }
          // dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          // dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateRole = (empId, data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/roles/${empId}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client response: ", result);

          if (result.success == true) {
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            func();
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAssetsdata = (token, assetType) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const url = `${BaseUrl}/api/assets?assetType=${assetType === "All" || assetType === undefined ? "" : assetType}`;

      fetch(url, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          dispatch({ type: LOGOUTLOADER, payload: true });
          console.log("get assets: ", result);
          dispatch({
            type: ADDASSET,
            payload: result?.assets?.length > 0 ? [...result?.assets] : [],
            // payload:  [...result?.assets] ,
          });
          dispatch({ type: LOGOUTLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOGOUTLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};
export const getRoleDropDown = (token) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/roles/dropdown`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("get role dropdown: ", result);
          dispatch({
            type: ROLEDROPDOWN,
            payload: result?.data?.length > 0 ? [...result?.data] : [],
          });
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};

export const getLead = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            dispatch({
              type: LEADDATA,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const deleteLead = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/leads/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          func();
          toast.success(<CustomToast type={"Success"} message={result?.message} />, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            icon: false,
            closeButton: false,
          });
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getLeadbyid = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      console.log(token, id, "pi");
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "haa");
            dispatch({
              type: LEADIDDATA,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const addLeadData = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(data, "data");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateLead = (leadId, data, token, func, func2) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(leadId, data, "uuu");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/${leadId}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client response: ", result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            dispatch({ type: SUBLOADER, payload: false });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            func2(true);
            dispatch({ type: SUBLOADER, payload: false });
          }
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const addConvertAccount = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(data, "data");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/customer-clients/convert-lead`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const getSupport = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/support`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            dispatch({
              type: SUPPORTDATA,
              payload: [...result?.requests],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getSupportById = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      console.log(token, id, "pi");
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/support/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "haa");
            dispatch({
              type: SUPPORTIDDATA,
              payload: { ...result?.request },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};

export const addSupport = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(data, "data");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/support`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const addReplyToSupportRequest = (id, data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(data, "data");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);
      console.log(data, token);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/support/${id}/reply`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const deleteAdminRequest = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/support/admin/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          func();
          console.log(result);
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const EmailMarkasread = (id, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/support/${id}/read`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client response: ", result);

          if (result.success == true) {
            func();
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getTask = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/tasks/client`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            dispatch({
              type: TASKSDATA,
              payload: [...result?.data.tasks],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getTaskbyId = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/tasks/taskdetails/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result?.data.tasks, "poi");
          if (result.success == true) {
            dispatch({
              type: TASKSDATAEMP,
              payload: [...result?.data.tasks],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const createTask = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(data, "uuu");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/tasks`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update client response: ", result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            dispatch({ type: SUBLOADER, payload: false });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            dispatch({ type: SUBLOADER, payload: false });
          }
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAssetsEmployee = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/assets/employee/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("get assets Employee: ", result);
          if (result.success === true) {
            dispatch({
              type: ASSETEMP,
              payload: [...result.assets],
            });
          }
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error);
  }
};
export const getLeadEmployee = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/EmployeeId/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "leademp");
          if (result.success === true) {
            dispatch({
              type: LEADEMP,
              payload: result.data.leads.length > 0 ? [...result.data.leads] : [],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getTravelEmployee = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/visits/employee/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "travelemp");
          if (result.success == true) {
            dispatch({
              type: TRAVELEMP,
              payload: [...result?.data?.visits],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const afterPayment = (data, token, func) => {
  try {
    return async (dispatch) => {
      console.log(JSON.stringify(data), "uuu");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/invoices/subscriptions`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("invoice response: ", result);

          if (result.success == true) {
            func(result);
            toast.success(<CustomToast type={"Success"} message={"Payment succeeded!"} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getInvoice = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/invoices`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "pi/invoices");
          if (result.success == true) {
            dispatch({
              type: INVOICE,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getInvoicebyid = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/invoices/client/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "pi/invoices/id");
          if (result.success == true) {
            dispatch({
              type: INVOICE,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const UploadImage = (data, token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: SUBLOADER, payload: true });
      console.log(data, "poiuy");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const formdata = new FormData();
      formdata.append("logo", data, data.name);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/files/upload`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "return");

          if (result.success == true) {
            func(result);
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getstats = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/${id}/statistics`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "rrrrrrrr");
          if (result.success == true) {
            console.log(result?.data.statistics, "pi/STATS/id");
            dispatch({
              type: STATS,
              payload: { ...result?.data.statistics },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getEmployeestats = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/stats?employeeId=${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "empolyee stats");
          if (result.success == true) {
            dispatch({
              type: EMPSTATS,
              payload: { ...result?.stats },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getQuaterlySales = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/graph?employeeId=${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "quatarly sales");
          if (result.success == true) {
            dispatch({
              type: QUATERLYSALES,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getadminstats = (token) => {
  try {
    //localhost:3001/api/client/dashboard-count
    http: return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/dashboard-count`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, "pi/STATS/id");
            dispatch({
              type: STATS,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getstatsassets = (token) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/assets/type-counts`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, "humza");
            dispatch({
              type: ASSETSSTATS,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getstatsassetsmangement = (token) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/assets/assets/types/assigned/counts`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, "assets/assets/types/assigned/counts");
            dispatch({
              type: ASSETSSTATSMANGEMENT,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getPipelineOverview = (token) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/dashboard/summary`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, " pipelineoverview");
            dispatch({
              type: PIPELINEOVERVIEW,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getTopSales = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}//api/client/${id}/target-progress?timeframe=monthly`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, " pipelineoverview");
            dispatch({
              type: TOPSALE,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getSales = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}//api/client/SalesOverview`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, "pipelineoverview");
            dispatch({
              type: SALE,
              payload: { ...result?.data },
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateAdmin = (clientId, data, token, func) => {
  try {
    return async (dispatch) => {
      console.log(data, "admin");
      dispatch({ type: SUBLOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/users/${clientId}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("update admin response: ", result);

          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: SUBLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: SUBLOADER, payload: false });

          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getBillInfo = (token, id) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}//api/client/billingInfo`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result?.data, "BILL");
            dispatch({
              type: BILL,
              payload: [...result?.data],
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getStatesByClientId = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/client/dashboardtotals?clientId=${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func(result);
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAllSubscriptionRequest = (token, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/subscriptions`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func(result);
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.log(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getTransactionByClientId = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/invoices/client/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func(result);
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAllSubscriptionRequestById = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${BaseUrl}/api/subscriptions/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func(result);
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const updateSubcriptionStatus = (token, data, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };
      fetch(`${BaseUrl}/api/subscriptions/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            func(result);
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAssetTypebyid = (token, id, func) => {
  try {
    return async (dispatch) => {
      // dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/asset-types/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            console.log(result, "pppp");
            func(result);
            dispatch({
              type: SINGLEASSET,
              payload: { ...result?.assetType },
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const deleteAsset = (id, func, token, show) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/asset-types/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            show(false);
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          console.log(result);
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};
export const getAssetsbyid = (token, id, func) => {
  try {
    return async (dispatch) => {
      // dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/assets/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "pppp");
          if (result.success == true) {
            func(result);
            dispatch({
              type: SINGLEASSETS,
              payload: { ...result?.asset },
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const deleteAssets = (id, func, token, show) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/assets/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            show(false);
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          console.log(result);
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error);
  }
};
export const getRevenue = (token, day, func) => {
  try {
    return async (dispatch) => {
      // dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/revenue-chart?timeRange=${day}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "REVENUE");
          if (result.success == true) {
            // func(result)
            dispatch({
              type: REVENUE,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getSaleGrowth = (token, day, id, func) => {
  try {
    return async (dispatch) => {
      // dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/client/${id}/sales-growth?timeRange=${day}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "SALE GROWTH");
          if (result.success == true) {
            // func(result)
            dispatch({
              type: SALEGROWTH,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADER, payload: false });
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getNotificationCount = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/Notifications/un-seen-count`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "Notifications/un-seen-count");
          if (result.success == true) {
            dispatch({
              type: NOTIFICATIONCOUNT,
              payload: { ...result?.data },
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getAllNotification = (token) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/Notifications?page=1&limit=1000`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result.data, "Notifications/all");
          if (result.success == true) {
            dispatch({
              type: NOTIFICATION,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const markAllSeen = (token, func) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/Notifications/mark-bulk-as-seen`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "api/Notifications/mark-bulk-as-seen");
          if (result.success == true) {
            func();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const markRead = (token, id, func) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const raw = JSON.stringify({
        notificationReceiverId: id,
      });
      console.log(raw, "id");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/Notifications/mark-as-read`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "api/Notifications/mark-as-read");
          if (result.success == true) {
            func();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const cancelSubscription = (token, id, func) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const raw = JSON.stringify({
        clientId: id,
      });
      console.log(raw, "id");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/payments/subscriptions/cancel`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "/subscriptions/cancel");
          if (result.success == true) {
            func();
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.error ? result?.error : result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getTopClient = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/leads/top-clients?employeeId=${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "Top client");
          if (result.success == true) {
            dispatch({
              type: TOPCLIENT,
              payload: [...result?.data],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getActivityById = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/activities/by-client/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success === true) {
            dispatch({
              type: ACTIVITYBYID,
              payload: [...result?.activities],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const collect = (token, id, val, func) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);
      const raw = JSON.stringify({
        mileage: val,
      });
      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };
      console.log(raw);
      fetch(`${BaseUrl}/api/assets/collect/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "collect", id);
          if (result.success == true) {
            toast.success(<CustomToast type={"Success"} message={result?.error ? result?.error : result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            func();
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.error ? result?.error : result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const getClientRecentActivites = (token, id) => {
  try {
    return async (dispatch) => {
      dispatch({ type: LOADER, payload: true });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/activities/by-client/${id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "RECENTACTIVITY");
          if (result.success == true) {
            dispatch({
              type: RECENTACTIVITY,
              payload: [...result?.activities],
            });
          }
          dispatch({ type: LOADER, payload: false });
        })
        .catch((error) => {
          console.error(error);
          dispatch({ type: LOADER, payload: false });
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
export const ClientGenerateReport = (token, data, func) => {
  try {
    return async (dispatch) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);
      const raw = JSON.stringify(data);

      const requestOptions = {
        method: "Post",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };

      fetch(`${BaseUrl}/api/report/generate`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(token, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "client generate");
          if (result.success == true) {
            func();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
  } catch (error) {
    console.log(error, "error");
  }
};
